// @ts-nocheck
import * as React from 'react';
import Icon from '../components/common/Icon';

const CONTENT_KEYS = {
  inspire: 'INSPIRE365',
  childcare: 'AI_CHILD_CARE',
  progress: 'AI_STUDENT_INFORMATION',
};

export default function FeatureDemoCards({ ranked, demos, onTrigger, content = {} }) {
  const availableCards = ranked
    .map(pillar => ({
      ...pillar,
      generatedContent: CONTENT_KEYS[pillar.id] ? content[CONTENT_KEYS[pillar.id]] : null,
    }))
    .filter(pillar => pillar.generatedContent && Object.values(pillar.generatedContent).some(Boolean));

  return (
    <div className="A-feat-list">
      {availableCards.map((p, i) => {
        const isTriggered = demos.some((d) => d.featureId === p.id);
        const generatedContent = p.generatedContent;
        const contentTitle = generatedContent?.TITLE || generatedContent?.HEADING;
        const contentMeta = generatedContent?.CATEGORY || generatedContent?.MODULE;
        const contentMessage = generatedContent?.MESSAGE || generatedContent?.ISSUE;
        return (
          <article key={p.id} className="A-feat">
            <div className="A-feat__rank">{`0${i + 1}`}</div>
            <div className="A-feat__icon" style={{ background: p.tint, color: p.color }}>
              <Icon name={p.icon} size={18} />
            </div>
            <div className="A-feat__main">
              <div className="A-feat__title">
                <span className="A-feat__name">{p.name}</span>
                <span className="A-feat__kind">{p.kind}</span>
              </div>
              {contentTitle && <div className="A-feat__tag">{contentTitle}</div>}
              <div className="A-feat__meta">
                {contentMeta && <span title={contentMessage || undefined}>{contentMeta}</span>}
              </div>
              {contentMessage && <div className="A-feat__content-message" title={contentMessage}>{contentMessage}</div>}
            </div>
            <div className="A-feat__assets" aria-label="Available demo assets">
              {(generatedContent.MESSAGE || generatedContent.ISSUE) && <span>Text</span>}
              {generatedContent.AUDIO_URL && <span>Audio</span>}
              {generatedContent.VIDEO_URL && <span>Video</span>}
            </div>
            <button
              className={"A-feat__cta " + (isTriggered ? "is-done" : "")}
              onClick={() => onTrigger({ ...p, generatedContent })}
            >
              {isTriggered ? (
                <>
                  <Icon name="check" size={13} stroke={2.2} />
                  Sent · Resend
                </>
              ) : (
                <>
                  Trigger demo
                  <Icon name="arrow-right" size={13} stroke={2} />
                </>
              )}
            </button>
          </article>
        );
      })}
    </div>
  );
}
